import { Component, OnInit } from '@angular/core';
import { LoginRequest } from '../models/login-request';
import { V2AuthService } from '../services/v2auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-v2login',
  templateUrl: './v2login.component.html',
  styleUrls: ['./v2login.component.scss']
})

export class V2loginComponent implements OnInit {
  email: string = '';
  validationError: string = '';
  successMessage: string = '';
  isSubmitting: boolean = false;

  constructor(
    private v2AuthService: V2AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {    
    this.v2AuthService.isLoggedIn().subscribe(isLogged => {
    if (isLogged) {
      this.router.navigate(['/redirection']);
    }
    });
  }

  onSubmit() {
    this.validationError = '';
    this.successMessage = '';
    this.isSubmitting = true;

    if (!this.email || this.email.trim() === '') {
      this.validationError = 'Email is required.';
      this.isSubmitting = false;
      return;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(this.email)) {
      this.validationError = 'Invalid email format.';
      this.isSubmitting = false;
      return;
    }

    const loginRequest: LoginRequest = { email: this.email.trim() };

    this.v2AuthService.requestLoginLink(loginRequest).subscribe({
      next: (response: any) => {
        this.successMessage = response.message;
        setTimeout(() => {
          this.isSubmitting = false;
        }, 5000);
      },
      error: (err) => {
        if (err.status === 404) {
          this.validationError = "We couldn't find an account with that email. Please try another or contact us.";
        } else {
          this.validationError = 'An error occurred while sending the login link. Please try again later.';
        }
        setTimeout(() => {
          this.isSubmitting = false;
        }, 1000);
      }
    });
  }
}